import request from "@/utils/request";

// 获取运营商全局配置
export default function getConfigs() {
  return request({
    url: `/common/agent/agentConfig/getConfigs`,
    method: "get",
  });
}
